<template>
  <div class="front-layout">
    <Header></Header>
    <router-view />
  </div>
</template>

<script setup lang="ts">
import Header from "../components/header.vue";
</script>

<style lang="scss" scoped>
.header {
  margin-bottom: 33px;
}

.front-layout {
  min-height: 100vh;
}

// The bottom nav (header.vue) is fixed and only shown below Vuetify's `md`
// breakpoint (960px) - reserve room so it never overlaps the last bit of
// page content on phones/tablets.
@media screen and (max-width: 959px) {
  .front-layout {
    padding-bottom: 84px;
  }
}
</style>
